/**
 * 用户可见错误文案的 i18n key（禁止把技术细节直接展示给用户）。
 */
export const USER_FACING_ERROR_I18N_KEYS = {
    APP_CRASH_MESSAGE: 'errorHandling.appCrashMessage',
    APP_CRASH_TITLE: 'errorHandling.appCrashTitle',
    GENERIC: 'errorHandling.generic',
    NETWORK: 'errorHandling.network',
    RELOAD: 'errorHandling.reload',
    TIMEOUT: 'errorHandling.timeout',
    UNAUTHORIZED: 'errorHandling.unauthorized'
};
/**
 * 错误降级分类。
 */
export var DegradedErrorCategory;
(function (DegradedErrorCategory) {
    DegradedErrorCategory["GENERIC"] = "generic";
    DegradedErrorCategory["NETWORK"] = "network";
    DegradedErrorCategory["TIMEOUT"] = "timeout";
    DegradedErrorCategory["UNAUTHORIZED"] = "unauthorized";
})(DegradedErrorCategory || (DegradedErrorCategory = {}));
/**
 * 判定技术性错误文本的正则（匹配则不得直接上屏）。
 */
export const TECHNICAL_ERROR_TEXT_PATTERNS = [
    /\bHTTP\s*[1-5]\d{2}\b/i,
    /\bstatus\s*[:=]?\s*[1-5]\d{2}\b/i,
    /\bECONNREFUSED\b/i,
    /\bENOTFOUND\b/i,
    /\bETIMEDOUT\b/i,
    /\bTypeError\b/i,
    /\bReferenceError\b/i,
    /\bSyntaxError\b/i,
    /\bNetworkError\b/i,
    /failed to fetch/i,
    /\bUnhandled\s*(Promise)?\s*Rejection\b/i,
    /\bat\s+\S+\s+\(/,
    /webpack/i,
    /stack\s*trace/i,
    /WEBPACK_DEV_SERVER/i,
    /^\s*Error:\s*/i
];
